import React, { useContext } from 'react';
import { Col, Table } from 'rsuite';
import { EquipmentContext } from '../utils/scope';

let attributes = {
  'pa_equipment-type': 'Type',
  'pa_equipment-make': 'Make',
  'pa_equipment-model': 'Model',
  'pa_equipment-year': 'Year',
  'pa_equipment-serial-number': 'Serial Number',
  'pa_equipment-stock-number': 'Stock Number',
  'pa_equipment-location': 'Location',
};
const attributesWidth = {
  'pa_equipment-type': 60,
  'pa_equipment-year': 60,
  'pa_equipment-location': 200,
};

const { Column, HeaderCell, Cell } = Table;

export const List = ({ items }) => {
  const isParts = useContext(EquipmentContext) === 'parts';

  let titleWidth = 200;

  if (isParts) {
    attributes = {};
    titleWidth = undefined;
  }

  return (
    <Col md={24}>
      <Table
        height={20 * 47}
        autoHeight
        // affixHeader
        data={items}
        // onRowClick={(data) => {
        //   console.log(data);
        // }}
      >
        <Column width={titleWidth} flexGrow={titleWidth > 0 ? null : 1} fixed={titleWidth > 0}>
          <HeaderCell></HeaderCell>
          <Cell>
            {({ post_title, url }) => {
              return (
                <a href={url} title={post_title}>
                  {post_title}
                </a>
              );
            }}
          </Cell>
        </Column>

        {Object.keys(attributes).map((attribute) => (
          <Column key={attribute} width={attributesWidth[attribute] || 160}>
            <HeaderCell>{attributes[attribute]}</HeaderCell>
            <Cell dataKey={attribute} />
          </Column>
        ))}
      </Table>
    </Col>
  );
};
